import { Component } from '@angular/core';
@Component({
  templateUrl: './about.component.html',
  styleUrls: ['../../shared/static-pages.scss'],
  standalone: false
})
export class AboutComponent {}
